export default __webpack_public_path__ + "static/technomedics-logo-7772d0d9688869725c1e6f61d3bb6706.png";